module.exports = __webpack_public_path__ + "img/Phone2.357ac84f.svg";